!(function () {
  "use strict";
  class t extends HTMLElement {
    constructor() {
      (super(),
        (this.boundHandleClick = this.handleClick.bind(this)),
        (this.boundResetATC = this.resetATC.bind(this)),
        (this.boundOptionChange = this.handleOptionChange.bind(this)),
        (this.boundScroll = this.toggleScroll.bind(this)));
    }
    connectedCallback() {
      ((this.section = this.closest(`section[data-section-type="product-template"]`)),
        (this.form = this.section?.querySelector("[data-product-form]")),
        this.section &&
          this.form &&
          ((this.formWrapper =
            (window.theme?.settings?.productPageSticky &&
              this.section.querySelector("[data-form-wrapper]")) ||
            this.form),
          (this.image = this.querySelector("[data-cart-bar-image]")),
          (this.options = this.querySelector("[data-cart-bar-options]")),
          (this.qty = this.querySelector("[data-cart-bar-qty]")),
          (this.atcBtn = this.querySelector("[data-cart-bar-add-to-cart]")),
          this.addEventListener("click", this.boundHandleClick),
          ["theme:cart:refresh", "theme:cart-bar:reset-atc-animation"].forEach(
            (t) => document.addEventListener(t, this.boundResetATC),
          ),
          this.initOptions(),
          this.initQty(),
          this.subVariant(),
          this.initObserver()));
    }
    resetATC() {
      (this.atcBtn?.classList.remove("is-loading"),
        this.atcBtn?.removeAttribute("disabled"));
    }
   handleClick(t) {
  if (t.target.closest("[data-scroll-to-form]")) {
    t.preventDefault();

    const form = this.section.querySelector("[data-product-form]");
    if (!form) return;

    form.setAttribute("tabindex", "-1");
    form.focus({
      preventScroll: true
    });

    form.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });

    return;
  }

  if (t.target.closest("[data-popout-toggle]")) {
    t.preventDefault();

    const wrapper = t.target.closest(".select-popout");
    const toggle = wrapper?.querySelector("[data-popout-toggle]");
    const list = wrapper?.querySelector("[data-popout-list]");

    if (!wrapper || !toggle || !list) return;

    const isOpen = toggle.getAttribute("aria-expanded") === "true";

    document.querySelectorAll(".select-popout [data-popout-list]").forEach((el) => {
      el.classList.remove("select-popout__list--visible");
    });

    document.querySelectorAll(".select-popout [data-popout-toggle]").forEach((el) => {
      el.setAttribute("aria-expanded", "false");
    });

    if (!isOpen) {
      list.classList.add("select-popout__list--visible");
      toggle.setAttribute("aria-expanded", "true");
    }

    return;
  }

  if (t.target.closest("[data-popout-option]")) {
    t.preventDefault();

    const option = t.target.closest("[data-popout-option]");
    const wrapper = option.closest(".select-popout");
    const input = wrapper.querySelector("[data-popout-input]");
    const text = wrapper.querySelector("[data-popout-text]");
    const item = option.closest(".select-popout__item");

    if (!option || !input || !text || !item) return;

    input.value = option.dataset.value;
    text.textContent = option.dataset.value;

    if (item.dataset.optionValueId) {
      input.setAttribute("data-option-value-id", item.dataset.optionValueId);
    }

    input.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );

    wrapper.querySelector("[data-popout-list]")?.classList.remove("select-popout__list--visible");
    wrapper.querySelector("[data-popout-toggle]")?.setAttribute("aria-expanded", "false");

    return;
  }

  if (t.target.closest("[data-cart-bar-add-to-cart]")) {
    t.preventDefault();

    const pdpAddToCartBtn = this.form.querySelector("[data-add-to-cart]");
    const mainQty = this.form.querySelector('[name="quantity"]');
    const stickyQty = this.querySelector("[data-quantity-field]");

    if (!pdpAddToCartBtn || pdpAddToCartBtn.hasAttribute("disabled")) return;

    if (mainQty && stickyQty) {
      mainQty.value = stickyQty.value || 1;

      mainQty.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }

    const stickyInputs = this.querySelectorAll("[data-popout-input]");

    stickyInputs.forEach((input) => {
      this.handleOptionChange({
        target: input
      });
    });

    this.atcBtn.classList.add("is-loading");
    this.atcBtn.setAttribute("disabled", true);

    setTimeout(() => {
      pdpAddToCartBtn.click();
    }, 300);

    setTimeout(() => {
      this.atcBtn.classList.remove("is-loading");
      this.atcBtn.removeAttribute("disabled");
    }, 1500);

    return;
  }
    }
    initOptions() {
      this.options
        ?.querySelectorAll("[data-popout-input]")
        .forEach((t) => t.addEventListener("change", this.boundOptionChange));
    }
handleOptionChange(t) {
  const input = t.target;
  const optionIndex = input.dataset.index;
  const selectedValue = input.value;

  if (!optionIndex || !selectedValue) return;

  const mainInput = this.section.querySelector(
    `[data-single-option-selector][data-index="${optionIndex}"][value="${CSS.escape(selectedValue)}"]`
  );

  if (!mainInput) return;

  if (mainInput.type === "radio") {
    mainInput.checked = true;
  } else {
    mainInput.value = selectedValue;
  }

  mainInput.dispatchEvent(
    new Event("change", {
      bubbles: true
    })
  );
}
    subVariant() {
      window.subscribe &&
        window.theme?.PUB_SUB_EVENTS?.variantChange &&
        (this.unsub = window.subscribe(
          window.theme.PUB_SUB_EVENTS.variantChange,
          ({ data: t }) => {
            const e = t?.sectionId;
            !e ||
              (e !== this.section.dataset.section &&
                e !== this.section.dataset.originalSection) ||
              (this.updateImage(t.variant),
              this.updateOptions(t.variant),
              this.updateBtn(t.variant),
              this.updatePrice(t.variant));
          },
        ));
    }
    updateImage(t) {
      const e = this.image?.querySelector("img"),
        i = t?.featured_media?.preview_image?.src;
      e && i && (e.src = `${i}${i.includes("?") ? "&" : "?"}width=160`);
    }
    updateOptions(t) {
      this.options &&
        t?.options &&
        this.options.querySelectorAll("popout-select").forEach((e) => {
          const i = e.querySelector("[data-popout-input]"),
            s = parseInt(i?.dataset.index?.replace("option", "") || "", 10);
          if (!i || isNaN(s)) return;
          const r = t.options[s - 1],
            a = e.querySelector("[data-popout-text]");
          e.querySelectorAll("[data-popout-option]").forEach((t) => {
            const s = t.dataset.value,
              o = s === r,
              n = t.closest("li");
            o &&
              n &&
              (a && (a.textContent = s),
              (i.value = s),
              n.dataset.optionValueId &&
                i.setAttribute("data-option-value-id", n.dataset.optionValueId),
              n.dataset.productUrl &&
                i.setAttribute("data-product-url", n.dataset.productUrl),
              e
                .querySelector(".select-popout__item--current")
                ?.classList.remove("select-popout__item--current"),
              n.classList.add("select-popout__item--current"),
              e
                .querySelector('[aria-current="true"]')
                ?.removeAttribute("aria-current"),
              t.setAttribute("aria-current", "true"));
            const c = n?.dataset.optionValueId;
            if (c) {
              const e = this.section.querySelector(
                `variant-selects [data-option-value-id="${CSS.escape(c)}"]`,
              );
              if (e) {
                const i =
                  e.closest(".sold-out, .unavailable") ||
                  e.classList.contains("unavailable") ||
                  e.disabled;
                t.classList.toggle("unavailable", i);
              }
            }
          });
        });
    }
    updateBtn(t) {
      const e = this.atcBtn,
        i = this.querySelector("[data-add-to-cart-text]");
      if (!e || !i || !t) return;
      const s = t.available;
      ((i.textContent =
        window.theme?.strings?.[s ? "addToCart" : "soldOut"] ||
        (s ? "Add to cart" : "Sold out")),
        e.toggleAttribute("disabled", !s));
    }
    updatePrice(t) {
      const e = this.querySelector("[data-product-price]");
      if (!e || !t) return;
      const i = (t) =>
        window.theme.formatMoney(
          t,
          window.theme?.settings?.currency_code_enable
            ? window.theme.moneyWithCurrencyFormat
            : window.theme.moneyFormat,
        );
      e.innerHTML =
        0 === t.price ? window.theme?.strings?.free || "Free" : i(t.price);
      const s = t.compare_at_price > t.price;
      e.classList.toggle("product__price--sale", s);
      const r = this.querySelector(".product__price--strike");
      r &&
        ((r.textContent = s ? i(t.compare_at_price) : ""),
        r.classList.toggle("hidden", !s));
    }
    initQty() {
  if (!this.qty) return;

  const barQty = this.qty.querySelector("[data-quantity-field]");
  const mainQty = this.form.querySelector('[name="quantity"]');

  if (!barQty || !mainQty) return;

  barQty.value = mainQty.value || 1;

  const syncQty = () => {
    let qty = parseInt(barQty.value) || 1;

    if (qty < 1) qty = 1;

    barQty.value = qty;
    mainQty.value = qty;

    mainQty.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );
  };

  this.qty.querySelector("[data-quantity-plus]")?.addEventListener("click", () => {
    barQty.value = (parseInt(barQty.value) || 1) + 1;
    syncQty();
  });

  this.qty.querySelector("[data-quantity-minus]")?.addEventListener("click", () => {
    let qty = parseInt(barQty.value) || 1;

    if (qty > 1) {
      barQty.value = qty - 1;
      syncQty();
    }
  });

  barQty.addEventListener("change", syncQty);
}
    initObserver() {
      "IntersectionObserver" in window && this.formWrapper
        ? ((this.obs = new IntersectionObserver(
            (t) => {
              t.forEach((t) =>
                this.classList.toggle(
                  "is-visible",
                  !t.isIntersecting && t.boundingClientRect.top < 0,
                ),
              );
            },
            {
              rootMargin: "0px",
              threshold: 0,
            },
          )),
          this.obs.observe(this.formWrapper))
        : document.addEventListener("theme:scroll", this.boundScroll);
    }
    toggleScroll() {
      this.formWrapper &&
        this.classList.toggle(
          "is-visible",
          window.scrollY >
            this.formWrapper.offsetTop + this.formWrapper.offsetHeight,
        );
    }
    disconnectedCallback() {
      (["theme:cart:refresh", "theme:cart-bar:reset-atc-animation"].forEach(
        (t) => document.removeEventListener(t, this.boundResetATC),
      ),
        this.obs
          ? this.obs.disconnect()
          : document.removeEventListener("theme:scroll", this.boundScroll),
        this.unsub?.(),
        this.removeEventListener("click", this.boundHandleClick),
        this.options
          ?.querySelectorAll("[data-popout-input]")
          .forEach((t) =>
            t.removeEventListener("change", this.boundOptionChange),
          ),
        this.mainQtyRef &&
          ["input", "change"].forEach((t) =>
            this.mainQtyRef.removeEventListener(t, this.syncMain),
          ),
        this.barQtyRef &&
          ["input", "change"].forEach((t) =>
            this.barQtyRef.removeEventListener(t, this.syncBar),
          ));
    }
  }
  customElements.get("cart-bar") || customElements.define("cart-bar", t);
})();